import ButtonIcon from '@design-system/buttonicon'

import { useCookieConsentPropsStore } from 'store/useCookieConsentProps'
import { useCookieConsentStore } from 'store/useCookieConsentStore'

import styles from './CookieConsentFloatingButton.module.scss'

/**
 * TCS-8180: floating entry point to re-open the cookie preferences center
 * after the user has already made an initial selection. Rendered as a
 * floating ButtonIcon on the bottom-left of the page, per UX spec.
 */
export default function CookieConsentFloatingButton() {
  /** CMS kill-switch: when the article sets it to false, nothing renders */
  const showCookieConsent = useCookieConsentPropsStore.use.showCookieConsent()

  const hasConsent = useCookieConsentStore.use.hasConsent()
  const isBannerVisible = useCookieConsentStore.use.isBannerVisible()
  const isPreferencesOpen = useCookieConsentStore.use.isPreferencesOpen()
  const hasOpenedPreferences = useCookieConsentStore.use.hasOpenedPreferences()
  const openPreferences = useCookieConsentStore.use.openPreferences()

  /**
   * Show the floating button once the user has made a consent decision
   * (banner CTAs or the preferences center) or has been in the configuration
   * flow at least once this session — so they can always review/change their
   * choices. Hidden while the banner or the preferences modal is on screen
   * (those are the entry points before the first selection).
   */
  if (
    !showCookieConsent ||
    (!hasConsent && !hasOpenedPreferences) ||
    isBannerVisible ||
    isPreferencesOpen
  ) {
    return null
  }

  return (
    <div className={styles.floatingButton}>
      <ButtonIcon
        iconButton="cookies"
        sizeButtonIcon="m"
        buttonBg
        buttonShadow
        onClick={openPreferences}
        aria-label="Preferências de cookies"
      />
    </div>
  )
}
